export default __webpack_public_path__ + "static/help_06_04-5-ba0d05b2a976960987842080d7613301.png";